/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manager_Question_Not_Listed_NoteInputs */



/**
* | output |
* | --- |
* | "No problem. Just say it in the chat later: ‘My manager is …’" |
*
* @param {Manager_Question_Not_Listed_NoteInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const manager_question_not_listed_note = /** @type {((inputs?: Manager_Question_Not_Listed_NoteInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manager_Question_Not_Listed_NoteInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Geen probleem. Zeg het later gewoon in de chat: ‘Mijn leidinggevende is …’")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Pas de problème. Dites-le simplement plus tard dans le chat : « Mon responsable est … »")
	return /** @type {LocalizedString} */ ("No problem. Just say it in the chat later: ‘My manager is …’")
});